var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_420_20583)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    y: 7.22266,
    width: 6.70317,
    height: 25.5552,
    rx: 3.35159,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2891,
    y: 13.0303,
    width: 5.80799,
    height: 27.483,
    rx: 2.904,
    transform: "rotate(-90 12.2891 13.0303)",
    fill: "url(#paint0_linear_420_20583)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2891,
    y: 13.0303,
    width: 5.80799,
    height: 20.1095,
    rx: 2.904,
    transform: "rotate(-90 12.2891 13.0303)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2891,
    y: 32.7773,
    width: 5.80799,
    height: 27.483,
    rx: 2.904,
    transform: "rotate(-90 12.2891 32.7773)",
    fill: "url(#paint1_linear_420_20583)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2891,
    y: 32.7773,
    width: 5.80799,
    height: 20.1095,
    rx: 2.904,
    transform: "rotate(-90 12.2891 32.7773)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2891,
    y: 22.9043,
    width: 5.80799,
    height: 27.483,
    rx: 2.904,
    transform: "rotate(-90 12.2891 22.9043)",
    fill: "url(#paint2_linear_420_20583)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2891,
    y: 22.9043,
    width: 5.80799,
    height: 14.747,
    rx: 2.904,
    transform: "rotate(-90 12.2891 22.9043)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5421 13.2629H55.4321V27.9629H53.5421V13.2629ZM60.167 13.2629H60.881L69.512 23.7209V13.2629H71.402V27.9629H70.688L62.057 17.4629V27.9629H60.167V13.2629ZM74.9679 13.2629H76.8579L81.8349 24.7919L86.8119 13.2629H88.7019L82.2339 27.9629H81.4359L74.9679 13.2629ZM92.2633 13.2629H100.663V14.8589H94.1533V19.6049H100.432V21.2009H94.1533V26.3669H100.747V27.9629H92.2633V13.2629ZM108.739 28.2569C107.087 28.2569 105.687 27.6969 104.539 26.5769L104.665 24.3929H104.875C105.421 25.0789 105.995 25.6319 106.597 26.0519C107.213 26.4579 107.927 26.6609 108.739 26.6609C109.607 26.6609 110.286 26.4299 110.776 25.9679C111.28 25.4919 111.532 24.8689 111.532 24.0989C111.532 23.3709 111.266 22.7619 110.734 22.2719C110.216 21.7679 109.439 21.2919 108.403 20.8439C107.283 20.3679 106.387 19.7659 105.715 19.0379C105.057 18.3099 104.728 17.4839 104.728 16.5599C104.728 15.8459 104.917 15.2159 105.295 14.6699C105.673 14.1239 106.177 13.7039 106.807 13.4099C107.451 13.1159 108.151 12.9689 108.907 12.9689C109.607 12.9689 110.251 13.0809 110.839 13.3049C111.427 13.5149 111.924 13.7949 112.33 14.1449L112.414 16.1609H112.141C111.665 15.6009 111.147 15.1809 110.587 14.9009C110.027 14.6209 109.446 14.4809 108.844 14.4809C108.13 14.4809 107.542 14.6769 107.08 15.0689C106.632 15.4469 106.408 15.9229 106.408 16.4969C106.408 17.1129 106.674 17.6589 107.206 18.1349C107.752 18.6109 108.536 19.0659 109.558 19.4999C110.804 20.0319 111.756 20.6549 112.414 21.3689C113.086 22.0689 113.422 22.8949 113.422 23.8469C113.422 24.6729 113.219 25.4219 112.813 26.0939C112.421 26.7659 111.868 27.2979 111.154 27.6899C110.44 28.0679 109.635 28.2569 108.739 28.2569ZM120.108 14.8589H116.244V13.2629H125.862V14.8589H121.998V27.9629H120.108V14.8589ZM129.791 13.2629H139.136V15.7829H132.773V19.1429H138.905V21.6629H132.773V25.4429H139.22V27.9629H129.791V13.2629ZM143.102 13.2629H147.743C149.199 13.2629 150.382 13.6409 151.292 14.3969C152.216 15.1529 152.678 16.1889 152.678 17.5049C152.678 18.4569 152.433 19.2689 151.943 19.9409C151.453 20.6129 150.774 21.1029 149.906 21.4109L153.833 27.9629H150.536L146.798 21.7469H146.084V27.9629H143.102V13.2629ZM147.491 19.1849C148.961 19.1849 149.696 18.6249 149.696 17.5049C149.696 16.3849 148.961 15.8249 147.491 15.8249H146.084V19.1849H147.491ZM162.982 13.2629H163.864L170.374 27.9629H167.476L166.384 25.4429H160.462L159.37 27.9629H156.472L162.982 13.2629ZM165.334 22.9229L163.423 18.4709L161.512 22.9229H165.334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_420_20583",
    x: -4,
    y: -4,
    width: 181.133,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_420_20583"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_420_20583",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_20583",
    x1: 15.1931,
    y1: 13.0303,
    x2: 15.1931,
    y2: 40.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357066,
    stopColor: "#115E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575008,
    stopColor: "#0F6E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795244,
    stopColor: "#0B943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA63E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_20583",
    x1: 15.1931,
    y1: 32.7773,
    x2: 15.1931,
    y2: 60.2604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357066,
    stopColor: "#115E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575008,
    stopColor: "#0F6E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#0B943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA63E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_420_20583",
    x1: 15.1931,
    y1: 22.9043,
    x2: 15.1931,
    y2: 50.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357066,
    stopColor: "#115E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575008,
    stopColor: "#0F6E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#0B943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA63E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIeLogo);
export default __webpack_public_path__ + "static/media/ie-logo.161082ffc3a141fe35b56de4095467da.svg";
export { ForwardRef as ReactComponent };